import { ChevronRightIcon } from '@reckon-web/icon';
import { Text } from '@reckon-web/text';
import { UserAvatar } from '@reckon-web/avatar';
import { Box } from '@reckon-web/box';
import { Flex } from '@reckon-web/flex';
import { Stack } from '@reckon-web/stack';
import { useTheme } from '@reckon-web/theme';
import { hexToRgb } from '@reckon-web/utils';
import { Divider } from '@reckon-web/divider';

import { EmailOrUsernameMasking } from '../../emailOrUsernameMasking';

type UserProps = {
  firstName: string;
  lastName: string;
  emailOrUsername: string;
  onClick: () => void;
  isDivider: boolean;
};

export const User = ({
  firstName,
  lastName,
  emailOrUsername,
  onClick,
  isDivider,
}: UserProps) => {
  const { palette } = useTheme();

  return (
    <Stack
      as="button"
      type="button"
      borderRadius="large"
      cursor="pointer"
      css={{
        '&:hover': {
          background: hexToRgb(palette.button.passive.background, 0.05),
          cursor: 'pointer',
        },
        '&:active': {
          background: hexToRgb(palette.button.passive.background, 0.1),
        },
      }}
      onClick={onClick}
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        paddingX="medium"
        paddingY="large"
      >
        <Box marginRight="small">
          <UserAvatar name={`${firstName} ${lastName}`} />
        </Box>

        <Stack flex={1}>
          <Text>{`${firstName} ${lastName}`}</Text>
          <EmailOrUsernameMasking>{emailOrUsername}</EmailOrUsernameMasking>
        </Stack>

        <Flex justifyContent="center" alignItems="center" marginLeft="large">
          <ChevronRightIcon color="dim" />
        </Flex>
      </Flex>
      {isDivider && <Divider />}
    </Stack>
  );
};
